import React from 'react';

import { string, shape, func, arrayOf } from 'prop-types';

import ClassNames from 'classnames';

import BaseComponent from '../.internal/BaseComponent';
import Label from '../label/Label';
import RadioButton from '../radio_button/RadioButton';
import Icon from '../icon/Icon';

import './RadioMenu.scss';

export default class RadioMenu extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      value: props.defaultValue
    };
  }

  handleChildrenChange = (checked, childrenValue) => {
    const { value, onChange } = this.props;

    if (!value) {
      this.setState({ value: childrenValue });
    }

    if (onChange) {
      onChange(childrenValue);
    }
  };

  childrenChecked = childrenValue => {
    const { value } = this.props;
    const valueToCheck =
      typeof value !== 'undefined' ? value : this.state.value;

    return valueToCheck === childrenValue;
  };

  render() {
    const { items, id, className, style } = this.props;
    const { handleChildrenChange, childrenChecked } = this;

    const classNames = ClassNames('RadioMenu', className);

    return (
      <div className={classNames} id={id} style={style}>
        {items.map(item => {
          const itemValue = item.value;
          const menuClass = ClassNames(
            'menu-item',
            itemValue === this.state.value ? 'checked-menu' : ''
          );
          return (
            item.value && (
              <span key={itemValue} className={menuClass}>
                <RadioButton
                  className="menu-radio-button"
                  onChange={handleChildrenChange}
                  value={itemValue}
                  checked={childrenChecked(itemValue)}
                />
                {!!item.icon && (
                  <Icon icon={item.icon} size="sm" className="menu-icon" />
                )}
                {!!item.label && (
                  <Label inline className="menu-label">
                    {item.label}
                  </Label>
                )}
              </span>
            )
          );
        })}
      </div>
    );
  }
}

RadioMenu.propTypes = {
  value: string,
  items: arrayOf(
    shape({
      icon: string,
      label: string,
      value: string
    })
  ),
  id: string,
  className: string,
  style: shape({}),
  onChange: func
};

RadioMenu.defaultProps = {
  value: undefined,
  items: [],
  id: undefined,
  className: '',
  style: {}
};
